// extracted by mini-css-extract-plugin
export var actionButton = "_jk-t";
export var buttonContainer = "_jk-0";
export var buttonContainer2 = "_jk-1";
export var buttonSection = "_jk-2";
export var details = "_jk-3";
export var dropdownItem = "_jk-5";
export var dropdownItemsContainer = "_jk-4";
export var fileInput = "_jk-r";
export var headerButton = "_jk-6";
export var icon = "_jk-7";
export var input = "_jk-8";
export var macroListItem = "_jk-9";
export var mainContent = "_jk-a";
export var microText = "_jk-b";
export var modal = "_jk-w";
export var optionsButton = "_jk-c";
export var paperclip = "_jk-s";
export var pillContent = "_jk-d";
export var preview = "_jk-e";
export var preview2 = "_jk-f";
export var quillEditor = "_jk-q";
export var selectedMacro = "_jk-g";
export var sidebar = "_jk-h";
export var sidebarHeader = "_jk-j";
export var sidebarList = "_jk-i";
export var sidebarListItem = "_jk-k";
export var sidebarSearch = "_jk-l";
export var snoozeDurationWrapper = "_jk-v";
export var statusPillContainer = "_jk-m";
export var tagsContainer = "_jk-n";
export var unselectedMacro = "_jk-o";
export var variable = "_jk-u";
export var wrapper = "_jk-p";